import { bucketContaining } from './agent-task-buckets';

/**
 * Whether a task's drill-in shows "View agent work" — the worker agent's own transcript.
 *
 * Not for a task that FINISHED without a worker conversation: no agent ever worked on it, so the transcript
 * could only ever say "No activity yet". That is a task Maestro made and closed in the chat itself — a
 * Wixel image generation tracks its image as one (`party-balloons`, reported 2026-10-28). Its "From your
 * chat" link already says where the work happened.
 *
 * Still there for a task that has not finished: an agent may pick it up, and its transcript then streams in.
 * A dashboard build is decided before this (the drill-in shows its Build result instead).
 *
 * An empty id is no conversation, as the task routes send `''` for none. Shared 1:1 with iOS
 * `AgentWorkRules.shows` and Android `taskShowsAgentWork`.
 */
export function showsAgentWork(task: { status?: string; agentConversationId?: string }): boolean {
  const bucket = bucketContaining(task.status);
  const finished = bucket === 'done' || bucket === 'failed';
  return !finished || !!task.agentConversationId;
}
